export class Goalboard {
    users: string[]
    workingDays: number[]
    goalWindowDays: number
    conversionWindowDays: number
    contactedGoal: number
    connectedGoal: number
    scheduledGoal: number
    showGoal: number
    conversionGoal: number
    refreshTime: number
    goalboardId: string
    companyId: string
    label: string
    createdAt: Date
    updatedAt: Date
    status: number
    resultType: 'relative' | 'absolute'
    showIcon: boolean
    goalType: 'global' | 'individual'
}
